import { styled } from '@mui/material';

import { differenceInSeconds } from 'date-fns';

import { useI18n } from '@app-velocity/i18n';

import { useReviewContext } from '../../../../hooks/useReviewContext';

const Completed = styled('span')({
  color: 'var(--color-green-600)',
});

const Canceled = styled('span')({
  color: 'var(--color-red-500)',
});

const StyledStatus = styled('span')({
  fontWeight: 600,
  marginRight: 2,
});

export const ReviewStatus = () => {
  const { t } = useI18n();
  const { review } = useReviewContext();
  const { status, startTime, finishTime } = review;

  const timeDifference = differenceInSeconds(
    finishTime ? new Date(finishTime) : new Date(),
    new Date(startTime)
  );
  const minutes = Math.floor(timeDifference / 60);
  const seconds = timeDifference - minutes * 60;

  switch (status) {
    case 'CANCELED':
      return (
        <Canceled>
          <StyledStatus>{t('prototypes:canceled')}</StyledStatus>
          {startTime && finishTime
            ? `(${t('prototypes:time', { minutes, seconds })})`
            : null}
        </Canceled>
      );
    case 'COMPLETED':
      return (
        <Completed>
          <StyledStatus>{t('prototypes:completed')}</StyledStatus>
          {startTime && finishTime
            ? `(${t('prototypes:time', { minutes, seconds })})`
            : null}
        </Completed>
      );
  }
};
